import React from "react";

import "./loader.scss";

function Loader() {
  return (
    <div className="loader">
      <div className="container">
        <div className="box"></div>
        <div className="box"></div>
      </div>
    </div>
  );
}

export default Loader;
